import React, { useEffect, useState } from "react";
import { Col, Form, Input, Row, Modal, message } from "antd";
import VitalService from "../../../../Services/VitalService";
import { IoClose } from "react-icons/io5";

const months = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12",
};

const AddIPDVitals = ({
  visible,
  onClose,
  onSuccess,
  patientId,
  accountId,
  clinicId,
  admissionId,
  rpmApplicable,
}) => {
  const [form] = Form.useForm();
  const [vitalMasterData, setVitalMasterData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    "Blood Pressure(SYS)": "",
    "Blood Pressure(DIA)": "",
    "Pulse Oxygen": "",
    "Heart Rate": "",
    "Respiration Rate": "",
    Temperature: "",
    Height: "",
    Weight: "",
    BMI: "",
    "Sugar Level": "",
    "Pain Score": "",
    Consciousness: "",
  });

  const fetchVitalMaster = () => {
    let payload = {
      status: 1,
    };
    VitalService.VitalMasterlist(payload)
      .then((result) => {
        setVitalMasterData(result.data || []);
      })
      .catch((err) => {
        console.error("Error fetching vital master list:", err);
      });
  };

  useEffect(() => {
    if (visible) {
      fetchVitalMaster();
      setFormData({
        "Blood Pressure(SYS)": "",
        "Blood Pressure(DIA)": "",
        "Pulse Oxygen": "",
        "Heart Rate": "",
        "Respiration Rate": "",
        Temperature: "",
        Height: "",
        Weight: "",
        BMI: "",
        "Sugar Level": "",
        "Pain Score": "",
        Consciousness: "",
      });
      form.resetFields();
    }
  }, [visible, form]);

  const calculateBMI = (height, weight) => {
    const heightInMeters = Number(height) / 100;
    if (!heightInMeters || isNaN(heightInMeters) || Number(weight) <= 0)
      return "";
    const bmi = Number(weight) / (heightInMeters * heightInMeters);
    return bmi.toFixed(1);
  };

  const handleInputChange = (value, fieldName) => {
    setFormData((prevFormData) => {
      const updated = {
        ...prevFormData,
        [fieldName]: value,
      };

      if (fieldName === "Height") {
        const weight = updated.Weight;
        const height = value;
        if (Number(height) > 0 && Number(weight) > 0) {
          updated.BMI = calculateBMI(height, weight);
        } else {
          updated.BMI = "";
        }
      } else if (fieldName === "Weight") {
        const height = updated.Height;
        const weight = value;
        if (Number(height) > 0 && Number(weight) > 0) {
          updated.BMI = calculateBMI(height, weight);
        } else {
          updated.BMI = "";
        }
      }

      return updated;
    });
  };

  const handleVitalSubmit = () => {
    const hasAnyValue = Object.values(formData).some(
      (val) =>
        val !== "" &&
        val !== null &&
        val !== undefined &&
        val !== 0 &&
        val !== "0",
    );

    if (!hasAnyValue) {
      message.warning(
        "Please fill in at least one field before submitting the form.!!",
      );
      return;
    }

    setIsLoading(true);
    const payload = [];
    const currDate = new Date().toUTCString();
    const dateArr = currDate.split(" ");
    const month = months[dateArr[2]];
    const date = dateArr[1];
    const year = dateArr[3];
    const constructedDate = year + "-" + month + "-" + date;
    const time = dateArr[4];
    const constructedDateTime = constructedDate + " " + time;

    const userObj =
      sessionStorage.getItem("login_result") ||
      localStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;
    const activePatient = JSON.parse(
      sessionStorage.getItem("patient") || "null",
    );

    const effectivePatientId = patientId || activePatient?.patientId;
    const effectiveAccountId =
      accountId || activePatient?.accountId || userData?.user?.account_Id;
    const effectiveClinicId =
      clinicId || activePatient?.clinicId || userData?.user?.clinic_Id;
   

    const FIELD_TO_VITAL_CODE = {
      "Blood Pressure(SYS)": "BPS",
      "Blood Pressure(DIA)": "BPD",
      "Pulse Oxygen": "SPO2",
      "Heart Rate": "HR",
      "Respiration Rate": "RR",
      Temperature: "TP",
      Height: "HI",
      Weight: "WE",
      BMI: "BMI",
      "Sugar Level": "SL",
      "Pain Score": "PS",
      Consciousness: "CC",
    };

    Object.entries(formData).forEach(([fieldName, value]) => {
      if (
        value === "" ||
        value === null ||
        value === undefined ||
        value === 0 ||
        value === "0"
      ) {
        return;
      }

      const targetCode = FIELD_TO_VITAL_CODE[fieldName];
      const vitalRange = vitalMasterData.find(
        (vital) =>
          (targetCode &&
            vital.vitalCode?.toUpperCase() === targetCode.toUpperCase()) ||
          vital.vitalName?.toLowerCase() === fieldName.toLowerCase() ||
          vital.vitalCode?.toLowerCase() === fieldName.toLowerCase(),
      );

      if (vitalRange) {
        payload.push({
          account_Id: effectiveAccountId,
          clinic_Id: effectiveClinicId,
          createdBy: userData?.user?.userId,
          createdDate: constructedDateTime,
          modifiedBy: userData?.user?.userId,
          modifiedDate: constructedDateTime,
          patientId: effectivePatientId,
          recordedDateTime: constructedDateTime,
          status: 1,
          units: vitalRange.units,
          value: value,
          vitalCode: vitalRange.vitalCode,
          vitalName: vitalRange.vitalName,
          patientClass: "IPD",
        });
      }
    });

    if (payload.length === 0) {
      setIsLoading(false);
      message.warning("No matching vital configurations found.");
      return;
    }

    VitalService.AddVitals(payload)
      .then((response) => {
        setIsLoading(false);
        message.success("IPD Vitals added successfully.");
        if (onSuccess) {
          onSuccess(response?.data);
        }
        if (onClose) {
          onClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        message.error("Error occurred. Please try after sometime.!!");
        console.error("Error saving IPD vitals:", error);
      });
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={720}
      maskClosable={false}
      destroyOnClose
      closeIcon={
        <IoClose className="text-xl text-gray-500 hover:text-gray-700" />
      }
      title={
        <div className="border-b pb-3">
          <h2 className="text-base font-bold text-[#3b3f97]">Add IPD Vitals</h2>
          <p className="text-xs text-gray-400 font-normal">
            Enter patient vital measurements
          </p>
        </div>
      }
    >
      <div className="pt-3">
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            {/* Blood Pressure */}
            <Col span={8}>
              <Form.Item
                label={
                  <span className="text-xs font-semibold text-gray-700">
                    Blood Pressure
                  </span>
                }
                className="mb-3"
              >
                <div className="w-full flex items-center rounded-lg border border-gray-300 h-10 px-2 bg-white focus-within:border-brand-primaryColor">
                  <Input
                    value={formData["Blood Pressure(SYS)"]}
                    onChange={(e) =>
                      handleInputChange(
                        e.target.value.replace(/\D/g, ""),
                        "Blood Pressure(SYS)",
                      )
                    }
                    maxLength={3}
                    placeholder="SYS"
                    className="border-none shadow-none text-center p-0 text-sm focus:shadow-none"
                    style={{ width: "45%" }}
                  />
                  <span className="text-gray-400 font-bold px-1">/</span>
                  <Input
                    value={formData["Blood Pressure(DIA)"]}
                    onChange={(e) =>
                      handleInputChange(
                        e.target.value.replace(/\D/g, ""),
                        "Blood Pressure(DIA)",
                      )
                    }
                    maxLength={3}
                    placeholder="DIA"
                    className="border-none shadow-none text-center p-0 text-sm focus:shadow-none"
                    style={{ width: "45%" }}
                  />
                </div>
              </Form.Item>
            </Col>

            {/* Pulse Oxygen */}
            <Col span={8}>
              <Form.Item
                label={
                  <span className="text-xs font-semibold text-gray-700">
                    Pulse Ox (SpO₂)
                  </span>
                }
                className="mb-3"
              >
                <Input
                  className="h-10 rounded-lg text-sm"
                  value={formData["Pulse Oxygen"]}
                  suffix={
                    <span className="text-gray-400 text-xs font-medium">%</span>
                  }
                  onChange={(e) =>
                    handleInputChange(e.target.value, "Pulse Oxygen")
                  }
                />
              </Form.Item>
            </Col>

            {/* Heart Rate */}
            <Col span={8}>
              <Form.Item
                label={
                  <span className="text-xs font-semibold text-gray-700">
                    Heart Rate (Pulse)
                  </span>
                }
                className="mb-3"
              >
                <Input
                  className="h-10 rounded-lg text-sm"
                  value={formData["Heart Rate"]}
                  suffix={
                    <span className="text-gray-400 text-xs font-medium">
                      bpm
                    </span>
                  }
                  onChange={(e) =>
                    handleInputChange(e.target.value, "Heart Rate")
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            {/* Respiration Rate */}
            <Col span={8}>
              <Form.Item
                label={
                  <span className="text-xs font-semibold text-gray-700">
                    Respiration Rate
                  </span>
                }
                className="mb-3"
              >
                <Input
                  className="h-10 rounded-lg text-sm"
                  value={formData["Respiration Rate"]}
                  suffix={
                    <span className="text-gray-400 text-xs font-medium">
                      breaths/min
                    </span>
                  }
                  onChange={(e) =>
                    handleInputChange(e.target.value, "Respiration Rate")
                  }
                />
              </Form.Item>
            </Col>

            {/* Temperature */}
            <Col span={8}>
              <Form.Item
                label={
                  <span className="text-xs font-semibold text-gray-700">
                    Temperature
                  </span>
                }
                className="mb-3"
              >
                <Input
                  className="h-10 rounded-lg text-sm"
                  value={formData.Temperature}
                  suffix={
                    <span className="text-gray-400 text-xs font-medium">
                      °F
                    </span>
                  }
                  onChange={(e) =>
                    handleInputChange(e.target.value, "Temperature")
                  }
                />
              </Form.Item>
            </Col>

            {/* Sugar Level */}
            <Col span={8}>
              <Form.Item
                label={
                  <span className="text-xs font-semibold text-gray-700">
                    Sugar Level
                  </span>
                }
                className="mb-3"
              >
                <Input
                  className="h-10 rounded-lg text-sm"
                  value={formData["Sugar Level"]}
                  suffix={
                    <span className="text-gray-400 text-xs font-medium">
                      mg/dl
                    </span>
                  }
                  onChange={(e) =>
                    handleInputChange(e.target.value, "Sugar Level")
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            {/* Height */}
            <Col span={8}>
              <Form.Item
                label={
                  <span className="text-xs font-semibold text-gray-700">
                    Height
                  </span>
                }
                className="mb-3"
              >
                <Input
                  className="h-10 rounded-lg text-sm"
                  value={formData.Height}
                  suffix={
                    <span className="text-gray-400 text-xs font-medium">
                      cm
                    </span>
                  }
                  onChange={(e) => handleInputChange(e.target.value, "Height")}
                />
              </Form.Item>
            </Col>

            {/* Weight */}
            <Col span={8}>
              <Form.Item
                label={
                  <span className="text-xs font-semibold text-gray-700">
                    Weight
                  </span>
                }
                className="mb-3"
              >
                <Input
                  className="h-10 rounded-lg text-sm"
                  value={formData.Weight}
                  suffix={
                    <span className="text-gray-400 text-xs font-medium">
                      kg
                    </span>
                  }
                  onChange={(e) => handleInputChange(e.target.value, "Weight")}
                />
              </Form.Item>
            </Col>

            {/* BMI */}
            <Col span={8}>
              <Form.Item
                label={
                  <span className="text-xs font-semibold text-gray-700">
                    BMI
                  </span>
                }
                className="mb-3"
              >
                <Input
                  className="h-10 rounded-lg text-sm bg-gray-50 text-gray-700 font-medium cursor-not-allowed"
                  disabled
                  value={formData.BMI}
                  suffix={
                    <span className="text-gray-400 text-xs font-medium">
                      kg/m²
                    </span>
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            {/* Pain Score */}
            <Col span={8}>
              <Form.Item
                label={
                  <span className="text-xs font-semibold text-gray-700">
                    Pain Score
                  </span>
                }
                className="mb-3"
              >
                <Input
                  className="h-10 rounded-lg text-sm"
                  value={formData["Pain Score"]}
                  suffix={
                    <span className="text-gray-400 text-xs font-medium">
                      Score
                    </span>
                  }
                  onChange={(e) =>
                    handleInputChange(e.target.value, "Pain Score")
                  }
                />
              </Form.Item>
            </Col>

            {/* Consciousness */}
            <Col span={8}>
              <Form.Item
                label={
                  <span className="text-xs font-semibold text-gray-700">
                    Consciousness
                  </span>
                }
                className="mb-3"
              >
                <Input
                  className="h-10 rounded-lg text-sm"
                  value={formData.Consciousness}
                  suffix={
                    <span className="text-gray-400 text-xs font-medium">
                      Score
                    </span>
                  }
                  onChange={(e) =>
                    handleInputChange(e.target.value, "Consciousness")
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="flex items-center justify-end gap-3 mt-4 pt-4 border-t border-gray-100">
            <button
              className="h-9 px-5 rounded-lg bg-white border border-gray-300 text-gray-700 text-xs font-semibold"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={isLoading}
              className="h-9 px-6 rounded-lg bg-brand-primaryColor text-white text-xs font-semibold shadow-sm  disabled:cursor-not-allowed disabled:opacity-50 transition"
              onClick={handleVitalSubmit}
            >
              {isLoading ? "Saving..." : "Save Vitals"}
            </button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default AddIPDVitals;
